module.exports = __webpack_public_path__ + "img/9791158880316.c18fd2a5.jpg";